export default function MembershipTable({ members, loading }) {
  return (
    <div className="w-full bg-white shadow rounded-lg overflow-hidden" dir="rtl">

      {/* LOADING SKELETON */}
      {loading && (
        <div className="p-6">
          <div className="animate-pulse space-y-3">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="h-6 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      )}

      {!loading && (
        <table className="w-full text-right border-collapse">
          <thead className="bg-gray-100 border-b border-gray-300">
            <tr>
              <th className="p-3 border-l border-gray-200">מס׳ חבר</th>
              <th className="p-3 border-l border-gray-200">שם משפחה</th>
              <th className="p-3 border-l border-gray-200">שם פרטי</th>
              <th className="p-3 border-l border-gray-200">תעודת זהות</th>
              <th className="p-3 border-l border-gray-200">דמי חבר</th>
              <th className="p-3 border-l border-gray-200">סוג תשלום דמי חבר</th>
              <th className="p-3 border-l border-gray-200">קל״ה</th>
              <th className="p-3">סוג תשלום קל"ה</th>
            </tr>
          </thead>

          <tbody>
            {members.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center p-4 text-gray-500">
                  אין תוצאות
                </td>
              </tr>
            )}

            {members.map((m) => (
              <tr
                key={m.id}
                className="border-b border-gray-200 hover:bg-gray-50 transition"
              >
                <td className="p-3 border-l border-gray-100">{m.number || "-"}</td>
                <td className="p-3 border-l border-gray-100">{m.lastName}</td>
                <td className="p-3 border-l border-gray-100">{m.firstName}</td>
                <td className="p-3 border-l border-gray-100">{m.idNumber}</td>

                {/* דמי חבר */}
                <td className="p-3 border-l border-gray-100">
                  {m.isActiveDues ? (
                    <span className="text-green-600 font-semibold">פעיל</span>
                  ) : (
                    <span className="text-red-600 font-semibold">לא פעיל</span>
                  )}
                </td>
                <td className="p-3 border-l border-gray-100">
                  {m?.viaPaymentDues=="PAY_CUSTOMER" ? (
                    <span className="text-green-600 font-semibold">חבר משלם</span>
                  ) : (
                    m?.viaPaymentDues=="MEMBER" ? <span className="text-green-600 font-semibold">הוראת קבע</span> : null
                  )}
                </td>
                {/* קל״ה */}
                <td className="p-3 border-l border-gray-100">
                  {m.isActiveAdvocacy ? (
                    <span className="text-green-600 font-semibold">פעיל</span>
                  ) : (
                    <span className="text-red-600 font-semibold">לא פעיל</span>
                  )}
                </td>
                <td className="p-3">
                  {m?.viaPaymentAdvocacy === "PAY_CUSTOMER" ? (
                    <span className="text-green-600 font-semibold">חבר משלם</span>
                  ) : m?.viaPaymentAdvocacy === "MEMBER" ? (
                    <span className="text-green-600 font-semibold">הוראת קבע</span>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
